import React from "react";
import {connect} from "react-redux";
import Footer from "../../components/common/utils/Footer";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import Banner from "../../components/common/Banner";
import * as actions from "../../redux/actions/Attendance/attendanceActions";

let from = new Date();
from.setDate(from.getDate() - 7);
let to = new Date();


let monDate = new Date();
let z1 = monDate.getDay() - 1;
if (z1 > 0)
  monDate.setDate(monDate.getDate() - z1);
else if (z1 == 0)
  monDate.setDate(monDate.getDate() - 7);
else
  monDate.setDate(monDate.getDate() - 7 + 1);

var default_search = {
  startDate: monDate,
  endDate: to,
  pageNo: 0
};
let default_team_search = {
  startDate: monDate,
  endDate: to,
  empId: null,
  indirect: false,
  vertical: false,
  pageNo: 0
};

let d1 = new Date();
let z = d1.getDay() - 1;
d1.setDate(d1.getDate() - z - 7);
let d2 = new Date();
z = d2.getDay() - 1;
d2.setDate(d2.getDate() - z);
d2.setDate(d2.getDate() - d2.getDay() + 1);
let d3 = new Date();
if(d1.getMonth() - 1 < 0) {
  d3.setFullYear(d1.getFullYear() - 1);
  d3.setMonth(11);
} else {
    d3.setFullYear(d1.getFullYear());
    d3.setMonth(d1.getMonth() - 1);
}
d3.setDate(d1.getDate());
let defaultRegSearch = {
  startDate: d3,
  endDate: d2,
    regStatus: "pending"
};

class TabsExampleSimple extends React.Component {
  constructor() {
    super();
    this.state = {
      dates: default_search,
      regDates: defaultRegSearch,
      teamDates: default_search,
      myPageNo: 0,
      teamPageNo: 0,
      regPageNo: 0,
      name: "My Attendance",
    };
    this.change_date = this.change_date.bind(this);
    this.changeRegDate = this.changeRegDate.bind(this);
    this.changeTeamDate = this.changeTeamDate.bind(this);
    this.changeRegPage = this.changeRegPage.bind(this);
    this.changeMyAttendancePage = this.changeMyAttendancePage.bind(this);
    this.changeTeamAttendancePage = this.changeTeamAttendancePage.bind(this);
    this.changeBanner = this.changeBanner.bind(this);
  }

  changeTeamDate(new_date) {
    this.setState({teamDates: new_date})
  }

  change_date(new_date) {
    this.setState({dates: new_date});
  }

  changeBanner(name) {
    this.setState({name: name});
  }

  changeRegDate(new_date) {
    this.setState({regDates: new_date, regPageNo: 0});
  }

  changeMyAttendancePage(pageNo) {
    this.props.dispatch(actions.getAttendance(this.state.dates, pageNo));
    this.setState({myPageNo: pageNo});
  }

  changeTeamAttendancePage(pageNo, request) {
    this.setState({teamPageNo: pageNo});
  }

  changeRegPage(pageNo) {
    this.props.dispatch(actions.getRegularisationAttendance(this.state.regDates, pageNo));
    this.setState({regPageNo: pageNo});
  }

  componentDidMount() {
    this.props.dispatch(actions.getRegularisationAttendance(defaultRegSearch, -1));
    this.props.dispatch(actions.getAttendance(default_search, -1));
    if (this.props.manager) {
      this.props.dispatch(actions.getTeamRegularisation());
      this.props.dispatch(actions.getTeamAttendance(default_team_search, -1));
    }
  }

  render() {
    return (
      <div style={{margin: 0}}>
        <div style={{margin: '0%', marginBottom: '0%', marginTop: '0px'}}>
          <Banner name={this.state.name}/>
          <div className="container" style={{marginLeft: '10', marginRight: '10', width: '100%'}}>
            <div className="wrapper-1">
              <div className="row clearfix">
                <div className="col-xs-12">
                  <div id="tab_content">
                    <ul className="nav nav-tabs tabs responsive" role="tablist">
                      <li
                        className={window.location.hash.split('?')[0].split('/')[3] == undefined || window.location.hash.split('?')[0].split('/')[3] == "myAttendance" ? "active" : null }
                        rel="apply"><a onClick={()=> {
                        this.setState({name: "My Attendance"})
                      }} href="#/1/attendance/myAttendance" rel="apply" role="tab" data-toggle="tab">My Attendance</a>
                      </li>
                      <li
                        className={window.location.hash.split('?')[0].split('/')[3] == "myAttendanceRegularisation" ? "active" : null }
                        rel="history"><a
                        onClick={()=> {
                          this.setState({name: "My Regularisation"})
                        }}
                        href="#/1/attendance/myAttendanceRegularisation" rel="history" role="tab" data-toggle="tab">My
                        Regularisation</a></li>

                      {this.props.manager ?
                        <li className={window.location.hash.split('?')[0].split('/')[3] == "team" ? "active" : null }
                            rel="team"><a
                          onClick={()=> {
                            this.setState({name: "Team Attendance"})
                          }}
                          href="#/1/attendance/team" rel="team" data-toggle="tab">Team Attendance</a></li> : null}
                      {this.props.manager ?
                        <li
                          className={window.location.hash.split('?')[0].split('/')[3] == "teamRegularisation" ? "active" : null }
                          rel="team"><a
                          onClick={()=> {
                            this.setState({name: "Team Regularisation"})
                          }}
                          href="#/1/attendance/teamRegularisation" rel="teams" data-toggle="tab">Team Regularisation</a>
                        </li> : null }
                      {(this.props.manager || this.props.employee.vertical) ?
                        <li
                          className={window.location.hash.split('?')[0].split('/')[3] == "teamRegularisationReport" ? "active" : null }
                          rel="team"><a
                          onClick={()=> {
                            this.setState({name: "Team Regularisation Report"})
                          }}
                          href="#/1/attendance/teamRegularisationReport" rel="teams" data-toggle="tab">Team Regularisation Report</a>
                        </li> : null
                      }
                      {((this.props.manager && (this.props.employee.function == 'Operations' || this.props.employee.function == 'Sales Operations' )) || this.props.employee.roster || this.props.employee.vertical) ?
                        <li
                          className={window.location.hash.split('?')[0].split('/')[3] == "teamRoster" ? "active" : null }
                          rel="team"><a
                          onClick={()=> {
                            this.setState({name: "Team Roster"})
                          }}
                          href="#/1/attendance/teamRoster" rel="teams" data-toggle="tab">Team Roster</a></li> : null}
                      {(this.props.employee.admin == true || (this.props.employee.empno == '1490' || this.props.employee.empno == '2416' || this.props.employee.empno == '2647')
                      || this.props.employee.empno == '1489' || this.props.employee.empno == '2173' || this.props.employee.empno == '2756' || this.props.employee.empno == '2424' ||
                      this.props.employee.empno=='2425' || this.props.employee.empno=='2756' || this.props.employee.attendanceUpload )
                        ?
                        <li
                          className={window.location.hash.split('?')[0].split('/')[3] == "attendanceUpload" ? "active" : null }
                          rel="team"><a onClick={()=> {
                          this.setState({name: "Attendance Upload"})
                        }} href="#/1/attendance/attendanceUpload" rel="teams" data-toggle="tab">Attendance Upload</a>
                        </li> : null}
                    </ul>

                    <div className="tab-content responsive">
                      <ReactCSSTransitionGroup transitionName="example"
                                               transitionAppear={true} transitionAppearTimeout={500}
                                               transitionEnter={false} transitionLeave={false}>
                        {React.cloneElement(this.props.children, {
                          myPageNo: this.state.myPageNo,
                          teamPageNo: this.state.teamPageNo,
                          regPageNo: this.state.regPageNo,
                          dates: this.state.dates,
                          regDates: this.state.regDates,
                          teamDates: this.state.teamDates,
                          isVertical: this.props.employee.vertical,
                          changePage: this.changeMyAttendancePage,
                          changeRegPage: this.changeRegPage,
                          changeTeamPage: this.changeTeamAttendancePage,
                          change_date: this.change_date,
                          changeRegDate: this.changeRegDate,
                          changeTeamDate: this.changeTeamDate,
                          changeBanner: this.changeBanner
                        })}
                      </ReactCSSTransitionGroup>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </div>);
  }

}

function mapStateToProps(state, ownState) {
  return {
    state: state.attendance[0].attendance,
    manager: state.emp[0].manager,
    employee: state.emp[0],
    loading: state.ajaxCallsInProgress
  };

}

export default connect(mapStateToProps)(TabsExampleSimple);



/** WEBPACK FOOTER **
 ** ./src/feature/attendance/AttendanceHome.js
 **/